import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

const resources = {
  zh: {
    translation: {
      // Navigation
      home: '首頁',
      issues: '期刊',
      photos: '相片',
      about: '關於',
      login: '登入',
      logout: '登出',
      admin: '管理',
      aiChat: 'AI 助手',
      lionVoice: '獅聲心語',
      
      // Common
      search: '搜尋',
      filter: '篩選',
      download: '下載',
      print: '列印',
      share: '分享',
      loading: '載入中...',
      error: '錯誤',
      success: '成功',
      cancel: '取消',
      confirm: '確認',
      save: '儲存',
      delete: '刪除',
      edit: '編輯',
      view: '查看',
      close: '關閉',
      next: '下一頁',
      previous: '上一頁',
      page: '頁',
      of: '共',
      
      // Home Page
      welcome: '歡迎來到港澳獅聲檔案館',
      welcomeDesc: '瀏覽、搜尋和下載國際獅子會中國港澳303區歷年期刊',
      featuredIssues: '精選期刊',
      latestIssues: '最新期刊',
      browseByYear: '按年份瀏覽',
      allIssues: '所有期刊',
      
      // Issue
      issue: '期刊',
      issueTitle: '期刊標題',
      issueDescription: '期刊說明',
      publicationYear: '出版年份',
      publicationMonth: '出版月份',
      publicationPeriod: '出版期數',
      periodQA: '1-3月',
      periodQB: '4-6月',
      periodQC: '7-9月',
      periodQD: '10-12月',
      periodQ1: '1-2月',
      periodQ2: '3-4月',
      periodQ3: '5-6月',
      periodQ4: '7-8月',
      periodQ5: '9-10月',
      periodQ6: '11-12月',
      volumeNumber: '卷號',
      issueNumber: '期號',
      totalPages: '總頁數',
      pages: '頁',
      viewIssue: '查看期刊',
      downloadIssue: '下載期刊',
      relatedPhotos: '相關相片',
      backToIssue: '返回期刊',
      viewInIssue: '在雜誌中查看',
      
      // Story
      stories: '文章',
      storyContent: '文章內容',
      additionalInfo: '額外資訊',
      partnerOrganization: '合作機構',
      keywords: '關鍵字',
      noPhotos: '此文章沒有相片',
      errorLoadingStory: '載入文章時發生錯誤',
      
      // Search & Filter
      searchPlaceholder: '搜尋期刊、內容...',
      filterByYear: '按年份篩選',
      filterByClub: '按獅子會篩選',
      filterByServiceType: '按服務類型篩選',
      filterByTags: '按標籤篩選',
      clearFilters: '清除篩選',
      noResults: '沒有找到結果',
      resultsFound: '找到 {{count}} 個結果',
      
      // PDF Viewer
      zoomIn: '放大',
      zoomOut: '縮小',
      fitWidth: '符合寬度',
      fitPage: '符合頁面',
      rotate: '旋轉',
      fullscreen: '全螢幕',
      downloadPage: '下載此頁',
      printPage: '列印此頁',
      pageNavigation: '頁面導航',
      thumbnail: '縮圖',
      content: '目錄',
      tableOfContents: '目錄',
      searchPages: '搜尋頁面內容...',
      otherPages: '其他頁面',
      noResultsFound: '未找到結果',
      errorLoadingPage: '無法載入頁面',
      noPageAvailable: '沒有可用的頁面圖像',
      
      // Photos
      photoGallery: '相片庫',
      photographer: '攝影師',
      photoDate: '拍攝日期',
      location: '地點',
      viewPhoto: '查看相片',
      downloadPhoto: '下載相片',
      
      // Admin
      uploadIssue: '上傳期刊',
      uploadPhoto: '上傳相片',
      manageIssues: '管理期刊',
      managePhotos: '管理相片',
      processingStatus: '處理狀態',
      pending: '等待中',
      processing: '處理中',
      completed: '已完成',
      failed: '失敗',
      reprocess: '重新處理',
      
      // Login
      username: '使用者名稱',
      password: '密碼',
      loginButton: '登入',
      loginError: '登入失敗，請檢查您的憑證',
      
      // Footer
      copyright: '© {{year}} 國際獅子會中國港澳三O三區',
      allRightsReserved: '版權所有',
      contactUs: '聯絡我們',
      privacyPolicy: '私隱政策',
      termsOfUse: '使用條款',
      
      // Tags
      serviceType: '服務類型',
      club: '獅子會',
      beneficiary: '受惠者',
      coOrganizer: '協辦單位',
      keyword: '關鍵字',
      
      // Errors
      errorLoadingIssues: '載入期刊時發生錯誤',
      errorLoadingPages: '載入頁面時發生錯誤',
      errorLoadingPhotos: '載入相片時發生錯誤',
      errorUploading: '上傳時發生錯誤',
      errorDeleting: '刪除時發生錯誤',
      errorProcessing: '處理時發生錯誤',
      
      // Success messages
      uploadSuccess: '上傳成功',
      deleteSuccess: '刪除成功',
      updateSuccess: '更新成功',

      // Brand & Search Page
      lionMagazine: '港澳獅聲',
      searchPageTitle: '內容搜尋',
      searchPageSubtitle: '搜尋獅聲雜誌各頁內容，包括投稿屬會、服務種類等',
      searchInputPlaceholder: '輸入關鍵字搜尋...（屬會、活動名稱、日期、地點、關鍵字等）',
      filterTitle: '篩選條件',
      yearLabel: '獅聲期刊年份',
      selectYear: '選擇年份...',
      quarterLabel: '季度',
      selectQuarter: '選擇季度...',
      clubLabel: '投稿者',
      enterClub: '輸入投稿者...',
      beneficiaryLabel: '受惠者',
      partnerLabel: '合作機構',
      coOrganizerLabel: '協辦單位',
      enterSearch: '輸入搜尋...',
      selectServiceType: '選擇服務類型...',
      excellentOnly: '顯示優質投稿 /相片',
      enterFiltersHint: '請輸入關鍵字或選擇篩選條件',
      enterFiltersToSearch: '請選擇篩選條件以開始搜尋',
      noResultsMatch: '沒有符合條件的結果。',
      resultsCount: '{{count}} 個結果',
      searchError: '搜尋時發生錯誤。請稍後再試。',
      colIssue: '期刊',
      colClub: '投稿者',
      colEventName: '活動名稱',      colDate: '日期',
      colLocation: '地點',
      colBeneficiary: '受惠者',
      colPartner: '合作機構',
      colKeywords: '關鍵字',      colServiceType: '服務種類',
      colSummary: '摘要',
      colLink: '連結',
      pageInfo: '第 {{page}} 頁，共 {{total}} 頁（{{count}} 筆結果）',
      perPage: '每頁',
      perPageUnit: '筆',
      district: '區會',
    },
  },
  en: {
    translation: {
      // Navigation
      home: 'Home',
      issues: 'Issues',
      photos: 'Photos',
      about: 'About',
      login: 'Login',
      logout: 'Logout',
      admin: 'Admin',
      aiChat: 'AI Chat',
      lionVoice: 'Lion Voice',
      
      // Common
      search: 'Search',
      filter: 'Filter',
      download: 'Download',
      print: 'Print',
      share: 'Share',
      loading: 'Loading...',
      error: 'Error',
      success: 'Success',
      cancel: 'Cancel',
      confirm: 'Confirm',
      save: 'Save',
      delete: 'Delete',
      edit: 'Edit',
      view: 'View',
      close: 'Close',
      next: 'Next',
      previous: 'Previous',
      page: 'Page',
      of: 'of',
      
      // Home Page
      welcome: 'Welcome to Lions Magazine Archive',
      welcomeDesc: 'Browse, search, and download past issues of Lions Magazine from District 303',
      featuredIssues: 'Featured Issues',
      latestIssues: 'Latest Issues',
      browseByYear: 'Browse by Year',
      allIssues: 'All Issues',
      
      // Issue
      issue: 'Issue',
      issueTitle: 'Issue Title',
      issueDescription: 'Issue Description',
      publicationYear: 'Publication Year',
      publicationMonth: 'Publication Month',
      publicationPeriod: 'Publication Period',
      periodQA: 'Jan-Mar',
      periodQB: 'Apr-Jun',
      periodQC: 'Jul-Sep',
      periodQD: 'Oct-Dec',
      periodQ1: 'Jan-Feb',
      periodQ2: 'Mar-Apr',
      periodQ3: 'May-Jun',
      periodQ4: 'Jul-Aug',
      periodQ5: 'Sep-Oct',
      periodQ6: 'Nov-Dec',
      volumeNumber: 'Volume Number',
      issueNumber: 'Issue Number',
      totalPages: 'Total Pages',
      pages: 'Pages',
      viewIssue: 'View Issue',
      downloadIssue: 'Download Issue',
      relatedPhotos: 'Related Photos',
      backToIssue: 'Back to Issue',
      viewInIssue: 'View in Magazine',
      
      // Story
      stories: 'Stories',
      storyContent: 'Story Content',
      additionalInfo: 'Additional Information',
      partnerOrganization: 'Partner Organization',
      keywords: 'Keywords',
      noPhotos: 'No photos available for this story',
      errorLoadingStory: 'Error loading story',
      
      // Search & Filter
      searchPlaceholder: 'Search issues, content...',
      filterByYear: 'Filter by Year',
      filterByClub: 'Filter by Club',
      filterByServiceType: 'Filter by Service Type',
      filterByTags: 'Filter by Tags',
      clearFilters: 'Clear Filters',
      noResults: 'No results found',
      resultsFound: '{{count}} results found',
      
      // PDF Viewer
      zoomIn: 'Zoom In',
      zoomOut: 'Zoom Out',
      fitWidth: 'Fit Width',
      fitPage: 'Fit Page',
      rotate: 'Rotate',
      fullscreen: 'Fullscreen',
      downloadPage: 'Download Page',
      printPage: 'Print Page',
      pageNavigation: 'Page Navigation',
      thumbnail: 'Thumbnail',
      content: 'Content',
      tableOfContents: 'Table of Contents',
      searchPages: 'Search pages...',
      otherPages: 'Other Pages',
      noResultsFound: 'No results found',
      errorLoadingPage: 'Unable to load page',
      noPageAvailable: 'No page image available',
      
      // Photos
      photoGallery: 'Photo Gallery',
      photographer: 'Photographer',
      photoDate: 'Photo Date',
      location: 'Location',
      viewPhoto: 'View Photo',
      downloadPhoto: 'Download Photo',
      
      // Admin
      uploadIssue: 'Upload Issue',
      uploadPhoto: 'Upload Photo',
      manageIssues: 'Manage Issues',
      managePhotos: 'Manage Photos',
      processingStatus: 'Processing Status',
      pending: 'Pending',
      processing: 'Processing',
      completed: 'Completed',
      failed: 'Failed',
      reprocess: 'Reprocess',
      
      // Login
      username: 'Username',
      password: 'Password',
      loginButton: 'Login',
      loginError: 'Login failed. Please check your credentials.',
      
      // Footer
      copyright: '© {{year}} Lions Clubs International District 303 Hong Kong & Macao, China',
      allRightsReserved: 'All Rights Reserved',
      contactUs: 'Contact Us',
      privacyPolicy: 'Privacy Policy',
      termsOfUse: 'Terms of Use',
      
      // Tags
      serviceType: 'Service Type',
      club: 'Club',
      beneficiary: 'Beneficiary',
      coOrganizer: 'Co-organizer',
      keyword: 'Keyword',
      
      // Errors
      errorLoadingIssues: 'Error loading issues',
      errorLoadingPages: 'Error loading pages',
      errorLoadingPhotos: 'Error loading photos',
      errorUploading: 'Error uploading',
      errorDeleting: 'Error deleting',
      errorProcessing: 'Error processing',
      
      // Success messages
      uploadSuccess: 'Upload successful',
      deleteSuccess: 'Delete successful',
      updateSuccess: 'Update successful',

      // Brand & Search Page
      lionMagazine: 'Lion Magazine',
      searchPageTitle: 'Content Search',
      searchPageSubtitle: 'Search content across Lions Magazine issues by club, event, service type, and more',
      searchInputPlaceholder: 'Search by keyword, club, event, date, location...',
      filterTitle: 'Filters',
      yearLabel: 'Year',
      selectYear: 'Select year...',
      quarterLabel: 'Quarter',
      selectQuarter: 'Select quarter...',
      clubLabel: 'Contributor',
      enterClub: 'Enter contributor...',
      beneficiaryLabel: 'Beneficiary',
      partnerLabel: 'Partner Organization',
      coOrganizerLabel: 'Co-organizer',
      enterSearch: 'Enter search...',
      selectServiceType: 'Select service type...',
      excellentOnly: 'Show excellent submissions / photos (優)',
      enterFiltersHint: 'Enter a keyword or select filters',
      enterFiltersToSearch: 'Select filters to start searching',
      noResultsMatch: 'No results match your filters.',
      resultsCount: '{{count}} results',
      searchError: 'Search error. Please try again later.',
      colIssue: 'Issue',
      colClub: 'Contributor',
      colEventName: 'Event Name',
      colDate: 'Date',
      colLocation: 'Location',
      colBeneficiary: 'Beneficiary',
      colPartner: 'Partner Organization',
      colKeywords: 'Keywords',
      colServiceType: 'Service Type',
      colSummary: 'Summary',
      colLink: 'Link',
      pageInfo: 'Page {{page}} of {{total}} ({{count}} results)',
      perPage: 'Per page',
      perPageUnit: '',
      district: 'District',
    },
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'zh',
    supportedLngs: ['zh', 'en'],
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
    },
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
